// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "xyz.nestwallet",
    name: "Nest Wallet",
    homepage: "https://nestwallet.xyz",
    image_id: "f8240c0b-97dd-4853-6a58-d10dadb2e800",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/nest-wallet/id6451122334",
        android: "https://play.google.com/store/apps/details?id=xyz.nestwallet.nestwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chromewebstore.google.com/detail/nest-wallet/cmoakldedjfnjofgbbfenefcagmedlga",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: "xyz.nestwallet",
    mobile: {
        native: "nestwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map